import { race } from "redux-saga/effects"
import { showToast } from "@infotech/uikit-toasts"
import fromSession from "./fromSession"

export default function*() {
  while (true) {
    const messages = yield race([fromSession()])

    for (let i = 0; i < messages.length; i += 1) {
      const message = messages[i]
      const firstStatusNumber = message[3].toString().charAt(0)
      const isError = firstStatusNumber === `4` || firstStatusNumber === `5`
      showToast({
        type: isError ? `error` : `success`,
        message: message[0],
        hideIn: 5,
      })
    }
  }
}
